import { MenuItem, MenuType } from '@models/menu';

export function isMenuFolder(item: MenuItem): boolean {
  return item.typeId ? item.typeId === MenuType.Folder : !!item.children?.length;
}

export function findMenuItemById(items: MenuItem[], id: number): MenuItem | undefined {
  for (const item of items ?? []) {
    if (item.id === id) {
      return item;
    }
    const found = findMenuItemById(item.children ?? [], id);
    if (found) {
      return found;
    }
  }
  return undefined;
}

/** @deprecated Prefer getAncestorFoldersInTree — parent refs can be stale after tree copies. */
export function getAncestorFolders(node: MenuItem): MenuItem[] {
  const ancestors: MenuItem[] = [];
  let current = node.parent;
  while (current) {
    ancestors.push(current);
    current = current.parent;
  }
  return ancestors.reverse();
}

/** Ancestor folders from the live tree data (correct object refs for MatTree.expand). */
export function getAncestorFoldersInTree(treeData: MenuItem[], nodeId: number): MenuItem[] {
  const ancestors: MenuItem[] = [];

  function search(items: MenuItem[], folderPath: MenuItem[]): boolean {
    for (const item of items ?? []) {
      if (item.id === nodeId) {
        ancestors.push(...folderPath);
        return true;
      }
      if (item.children?.length) {
        const nextFolderPath = isMenuFolder(item) ? [...folderPath, item] : folderPath;
        if (search(item.children, nextFolderPath)) {
          return true;
        }
      }
    }
    return false;
  }

  search(treeData, []);
  return ancestors;
}
